import useComputed from '@/hooks/use-computed'
import useSchemaProperties from '@/hooks/use-schema-properties'
import api from '@/services/api/dataElementsEnrolment.js'
import { immerable } from "immer"
import { useState } from 'react'
class DataElement {

	[immerable] = true

	constructor(params) {
		this.dataElement = params.dataElement
		this.modified = params.modified
		this.useCase = params.useCase
		this.system = params.system
		this.requiredFields = params.requiredFields
		this.optionalFields = params.optionalFields
		this.attachmentFields = params.attachmentFields
		this.type = params.type
		this.participants = params.participants
	}
}

const useDataElements = () => {

	const [items, setItems] = useComputed([])

	const { getRequiredFields, getOptionalFields, getAttachments } = useSchemaProperties();

	const [meta, setMeta] = useState(null)
	
	const [loading, setLoading] = useState(false)
	const [currentItem, setCurrentItem] = useState(null)
	const [error, setError] = useState()

	async function find(parameter) {

		const params = parameter ? parameter : "";

		setLoading(true)

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!Array.isArray(data.items)) {
			return setError('Data Elements Enrolment is not an array')
		}

		const serializedData = data.items.map(entry => serialize(entry))
		const dataElementItems = serializedData.map(params => new DataElement(params))

		return dataElementItems
	}

	async function fetch(parameter) {

		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		const { meta } = data

		if (!Array.isArray(data.items)) {
			return setError('Data Elements Enrolment is not an array')
		}

		const serializedData = data.items.map(entry => serialize(entry))
		const dataElementItems = serializedData.map(params => new DataElement(params))

		setMeta(meta)
		return setItems(dataElementItems)
	}

	function serialize(entry) {

		const attachmentFields = getAttachments(entry.dataElement?.dataElementSchema)
		const requiredFields = getRequiredFields(entry.dataElement?.dataElementSchema)
		const optionalFields  = getOptionalFields(entry.dataElement?.dataElementSchema)
		
		return {
			dataElement: entry.dataElement,
			modified: entry.modifiedAt,
			useCase: entry.useCase,
			system: entry.systems,
			requiredFields: requiredFields,
			optionalFields: optionalFields,
			attachmentFields: attachmentFields,
			type: entry.type,
			participants: entry.participants
		}
	}

	function view(id) {
		const newCurrentItem = items.find(Obj => Obj.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		find,
		meta,
	}

}

export default useDataElements
